export default __webpack_public_path__ + "assets/thunderstorms-rain.54936cd7.svg";